var turnplate = {
  restaraunts: [], //大转盘奖品名称
  colors: [], //大转盘奖品区块对应背景颜色
  outsideRadius: 190, //大转盘外圆的半径
  textRadius: 85, //大转盘奖品位置距离圆心的距离
  insideRadius: 35, //大转盘内圆的半径
  startAngle: 0, //开始角度
  bRotate: false //false:停止;ture:旋转
};

import jQuery from 'jquery';
import axios from 'axios'
require('./rotate.js')
export default class Lottery {
  constructor(prizeList, colorList, result, afterRotate, prizeListId, check, isClick) {
    turnplate.restaraunts = prizeList;
    turnplate.colors = colorList;
    this.afterRotate = afterRotate;
    this.result = result;
    this.logId = '';
    this.prizeListId = prizeListId;
    this.check = check;
    this.id = '';
    this.checkId = [1, 2, 3, 4, 5, 0];
    this.drawWheel();
    this.addEventListener();
    this.isClick = true;
  }

  /**
   * 旋转方法
   * @param  {[type]} item [description]
   * @return {[type]}      [description]
   */
  rotateFn(item) {
    var angles = item * (360 / turnplate.restaraunts.length) - (360 / (turnplate.restaraunts.length * 2));
    if (angles < 270) {
      angles = 270 - angles;
    } else {
      angles = 360 - angles + 270;
    }
    let that = this;
    jQuery('#wheelcanvas').stopRotate();
    jQuery('#wheelcanvas').rotate({
      angle: 0,
      animateTo: angles + 1800,
      duration: 5000,
      callback: function () {
        that.afterRotate(item);
        turnplate.bRotate = !turnplate.bRotate;
        that.isClick = true;
      }
    });
  }

  /**
   * 抽取随机
   * @param  {[type]} n [description]
   * @param  {[type]} m [description]
   * @return {[type]}   [description]
   */
  rnd(n, m) {
    var random = Math.floor(Math.random() * (m - n + 1) + n);
    return random;
  }

  /**
   * 添加监听事件
   */
  addEventListener() {
    let that = this;
    $('.pointer').click(function () {
      if (that.isClick) {
        that.isClick = false;
        axios.post('/haidu/api/h/activityTurntable/check', that.check).then(res => {
          if (res.data.success) {
            let Oid = res.data.data.awardId;
            $('.oldId').html(res.data.data.id);
            for (let i = 0; i < that.prizeListId.length; i++) {
              if (Oid === that.prizeListId[i]) {
                that.id = that.checkId[i];
              }
            }
            that.rotateFn(that.id);
          } else {
            app.alert({
              title: '',
              message: res.data.message
            })
            that.isClick = true;
          }
        })
      }
      let canRotate = $(this).attr('data-root');
      // console.log(canRotate)
      // if (!eval(canRotate)) {
      //   app.alert({
      //     title: '',
      //     message: '每个人只有一次机会哦~'
      //   })
      //   return false;
      // }
      if (turnplate.bRotate) return;
      turnplate.bRotate = !turnplate.bRotate;
    });
  }

  /**
   * 绘制转盘
   * @return {[type]} [description]
   */
  drawWheel() {
    var canvas = document.getElementById("wheelcanvas"),
      w = window.innerWidth * 0.8,
      dpr = $('html').attr('data-dpr');
    canvas.width = w * 2;
    canvas.height = w * 2;
    //设置半径
    let hv = canvas.width / 2,
      borderWidth = ((35 / 570) * (canvas.width)).toFixed(0);
    turnplate.outsideRadius = hv - borderWidth;
    turnplate.textRadius = (hv - turnplate.insideRadius) / 1.5;
    $('.turnplate').height(w + 'px');
    if (canvas.getContext) {
      //根据奖品个数计算圆周角度
      var arc = Math.PI / (turnplate.restaraunts.length / 2);
      var ctx = canvas.getContext("2d");
      //在给定矩形内清空一个矩形
      ctx.clearRect(0, 0, canvas.width, canvas.width);
      //strokeStyle 属性设置或返回用于笔触的颜色、渐变或模式  
      ctx.strokeStyle = "#FFBE04";
      //font 属性设置或返回画布上文本内容的当前字体属性
      ctx.font = 'bold ' + (24 * dpr) + 'px Microsoft YaHei';
      for (var i = 0; i < turnplate.restaraunts.length; i++) {
        var angle = turnplate.startAngle + i * arc;
        ctx.fillStyle = turnplate.colors[i];
        ctx.beginPath();
        //arc(x,y,r,起始角,结束角,绘制方向) 方法创建弧/曲线（用于创建圆或部分圆）    
        ctx.arc(hv, hv, turnplate.outsideRadius, angle, angle + arc, false);
        ctx.arc(hv, hv, turnplate.insideRadius, angle + arc, angle, true);
        ctx.stroke();
        ctx.fill();
        //锁画布(为了保存之前的画布状态)
        ctx.save();

        //----绘制奖品开始----
        ctx.fillStyle = "#ffffff";
        var text = turnplate.restaraunts[i];
        var line_height = 17;
        //translate方法重新映射画布上的 (0,0) 位置
        ctx.translate(hv + Math.cos(angle + arc / 2) * turnplate.textRadius, hv + Math.sin(angle + arc / 2) * turnplate.textRadius);

        ctx.rotate(angle + arc / 2 - 20 *
          Math.PI / 2);

        ctx.fillText(text, -ctx.measureText(text).width / 2, 0);
        ctx.restore();
        //----绘制奖品结束----
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/lottery.js